import React, { Component } from 'react';
import { Button, Modal } from 'semantic-ui-react'

class NotificationModal extends Component {

  render() {
    const { close, message, header, className } = this.props
    return (
      <Modal className={className ? `confirm-modal ${className}` : 'confirm-modal'} size="tiny" open={ true }>
        <Modal.Header>{ header }</Modal.Header>
        <Modal.Content>
          { message }
        </Modal.Content>
        <i className="delete icon" onClick={ close }></i>
      </Modal>
    )
  }
}

export default NotificationModal



// WEBPACK FOOTER //
// ./src/components/notification_modal.js